module.exports = __webpack_public_path__ + "img/laptop.78305ec3.svg";